"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFormDto = void 0;
const AppDto_1 = require("../apps/AppDto");
class CustomFormDto {
    constructor(params) {
        this.name = "";
        this.destinationEmail = "";
        this.includeProfile = false;
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.name = params.name;
        this.destinationEmail = params.destinationEmail;
        this.includeProfile = params.includeProfile;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.app !== undefined) {
            this.app = params.app === null ?
                null :
                new AppDto_1.AppDto(params.app);
        }
    }
}
exports.CustomFormDto = CustomFormDto;
//# sourceMappingURL=CustomFormDto.js.map